module.exports = __webpack_public_path__ + "static/media/maybank.7f304f76.png";